import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Eye, X } from "lucide-react";

export function ApercuEmail({ contenu, mode = "campagne", signatureId = null, testid = "apercu-email" }) {
  const [html, setHtml] = useState(null);
  const [busy, setBusy] = useState(false);

  const open = async () => {
    if (!contenu || !contenu.replace(/<[^>]*>/g, "").trim()) {
      toast.error("Rédigez d'abord le contenu du message");
      return;
    }
    setBusy(true);
    try {
      const r = await api("/admin/messagerie/apercu", {
        method: "POST",
        body: { contenu_html: contenu, mode, signature_id: signatureId },
      });
      setHtml(r.html);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" data-testid={`${testid}-button`} onClick={open} disabled={busy}
        className="inline-flex items-center gap-2 bg-white text-cfhtb-primary border border-cfhtb-primary rounded-md px-4 py-2 text-sm font-medium hover:bg-cfhtb-bg transition-colors disabled:opacity-50">
        <Eye className="h-4 w-4" /> {busy ? "Chargement…" : "Aperçu de l'email"}
      </button>
      {html && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 animate-fade-in"
          data-testid={`${testid}-modal`} onClick={() => setHtml(null)}>
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
              <h3 className="font-serif text-lg font-semibold text-cfhtb-heading">Aperçu de l'email</h3>
              <button type="button" data-testid={`${testid}-close`} onClick={() => setHtml(null)}
                className="p-1.5 rounded text-cfhtb-text hover:bg-slate-100 transition-colors">
                <X className="h-5 w-5" />
              </button>
            </div>
            <iframe title="Aperçu email" data-testid={`${testid}-frame`} srcDoc={html} sandbox=""
              className="w-full flex-1 min-h-[400px] bg-slate-50" />
            <p className="px-4 py-2 text-xs text-cfhtb-text/70 border-t border-slate-100">
              Les variables sont remplacées par vos informations à titre d'exemple. La signature et le logo sont ceux réellement envoyés.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
